/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.17",
    versionName: "0.2.0-nightly.2025.9.17",
    versionChannel: "nightly",
    buildDate: "2025-09-17T00:07:42.033Z",
    commitHash: "ce9274ffc225e7558ffa309464048b707dbb81da",
};
